import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { CejV2TestimonialModule } from '@domains/cej-v2/cej-v2-testimonial/cej-v2-testimonial.component';
import { Testimonial, TESTIMONIALS } from '@domains/cej-v2/cej-v2-testimonials/testimonials';

@Component({
  selector: 'app-cej-v2-testimonials',
  templateUrl: './cej-v2-testimonials.component.html',
  styleUrls: ['./cej-v2-testimonials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2TestimonialsComponent {
  TESTIMONIALS = TESTIMONIALS;

  trackByTestimonial(_: number, testimonial: Testimonial): string {
    return testimonial.title;
  }
}

@NgModule({
  imports: [CommonModule, CejV2TestimonialModule],
  declarations: [CejV2TestimonialsComponent],
  exports: [CejV2TestimonialsComponent],
})
export class CejV2TestimonialsModule {}
